<template>
  <div
    v-if="this.$store.state.afterfilterEmpty == false"
    class="content-grid"
    row
    wrap
  >
    <div v-if="myProducts.length > 0" class="content-items">
      <productCard
        v-for="(spaces, idx) in myProducts"
        :key="idx"
        :space="spaces"
        :mainProps="mainProps"
      ></productCard>
    </div>
    <loader v-else name="null"></loader>
  </div>

  <div v-else class="empty">
    <img src="../assets/illustrations/empty.svg" class="empty-ill" />
    Oops, Nothing found!
  </div>
</template>

<script>
import productCard from "../components/productCardDesign";
import loader from "../components/loader";
export default {
  components: {
    productCard,
    loader
  },
  data() {
    return {
      mainProps: {
        center: true,
        fluidGrow: true,
        blank: true,
        blankColor: "#bbb",
        width: 600,
        height: 400,
        class: "my-5"
      },
      month: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec"
      ]
    };
  },
  computed: {
    myProducts() {
      if (
        this.$store.state.filterProducts.length > 0 &&
        this.$store.state.filterProductsWithPrice.length == 0
      ) {
        // console.log("filter with no price");
        // console.log(this.$store.state.filterProducts.length);
        return this.$store.state.filterProducts;
      } else if (this.$store.state.filterProductsWithPrice.length > 0) {
        // console.log("filter with price");
        // console.log(this.$store.state.filterProductsWithPrice);
        return this.$store.state.filterProductsWithPrice;
      } else {
        // console.log("no filter");
        // console.log(this.$store.state.products);
        return this.$store.state.products;
      }
    }
  },
  created() {},
  methods: {
    monthChange(e) {
      return this.month[parseInt(e.split("-")[1])];
    },
    dataChange(e) {
      return e.split("-")[2];
    },
    showproduct(e) {
      this.$store.dispatch("selectedProduct", {
        sel: e
      });
      this.$router.push({ name: "product", params: { Pid: e.spaceid } });
    }
  }
};
</script>

<style scoped>
/* comman css */
.empty {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.empty-ill {
  height: 50%;
  margin-bottom: 15px;
}
.empty {
  font-size: 16px;
  font-weight: bold;
}
.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.3em;
  opacity: 0.8;
  width: 100%;
}
.hr-text:before {
  content: "";
  background: linear-gradient(to right, transparent, #818078, transparent);
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}
.hr-text:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: black;
  padding: 0 0.5em;
  line-height: 1.5em;
  color: black;
  background-color: #fcfcfa;
}
/* common css */
@media only screen and (max-width: 600px) {
  .ad-price {
    width: 100%;
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #4415e5;
    margin: 2px 0px 0px 0;
  }
  .ad-landmark {
    width: 100%;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    margin: 0px 0px 2px 0;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0px 10px;
  }
  .ad-location {
    width: 100%;
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    margin: 0px 0px 2px 0;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0px 10px;
  }
  .date-date {
    color: black;
  }
  .date-month {
    color: #9d8b16;
  }
  .between-date-hr {
    width: 10em !important;
  }
  .date-child {
    display: flex;
    flex-direction: column;
  }
  .date-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: center;
    padding: 0 10px;
    font-size: 12px;
  }
  .product-img {
    max-height: 7em;
    height: 7em;
    width: 10em !important;
    border-radius: 10px;
    margin-top: 10px !important;
    margin-bottom: 5px !important;
  }
  .content-grid {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
  .content-items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    align-items: flex-start;
    justify-content: space-evenly;
  }
  .content-card {
    width: 11em;
    height: 285px;
    border-radius: 10px;
    background-color: #f9fbfc;
    margin: 0 5px 10px 5px;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    text-align: center;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    position: relative;
  }
  .after-hr {
    width: 100%;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
  }
}
@media only screen and (min-width: 700px) {
  .after-hr {
    width: 100%;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
  }
  .ad-price {
    width: 100%;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #4415e5;
    margin: 2px 0px 0px 0;
  }
  .ad-landmark {
    width: 100%;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    margin: 2px 0px 5px 0;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0px 10px;
  }
  .ad-location {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    margin: 3px 0px 5px 0;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0px 10px;
  }
  .date-date {
    color: black;
  }
  .date-month {
    color: #9d8b16;
  }
  .between-date-hr {
    width: 10em !important;
  }
  .date-child {
    display: flex;
    flex-direction: column;
  }
  .date-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: center;
  }
  .product-img {
    max-height: 9em;
    height: 9em;
    width: 14em !important;
    border-radius: 10px;
    margin-top: 15px !important;
    margin-bottom: 5px !important;
  }
  .content-grid {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
  .content-items {
    /* display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 96%;
    align-items: flex-start; */
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 0fr));
    grid-gap: 25px;
    width: 90%;
  }
  .content-card {
    width: 254px;
    height: 352px;
    border-radius: 10px;
    background-color: #f9fbfc;
    /* margin: 0 17px 25px 17px; */
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    position: relative;
  }
}
</style>
